module.exports = __webpack_public_path__ + "media/sr3.58fd7714.mp4";